import React from "react";

export default function CardWithHeaderSubTitle({ subTitle }) {
    return (
        <div className="text-sm font-semibold uppercase text-tm-gray-500 mb-4">
            {subTitle}
        </div>
    );
}
